import { useLoading } from "context/LoadingContext";
import { ToastContext } from "context/ToastContext";
import useDocumentTitle from "hooks/useDocumentTitle";
import { useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCreateProfessionalRulesetMutation } from "store/queries/professionalRuleset";

import {
  IProfessionalRulesetFormData,
  INITIAL_PROFESSIONAL_FORM_DATA,
  ProfessionalRulesetForm,
} from "./components/ProfessionalRulesetForm";

export function CreateProfessionalRulesetPage() {
  useDocumentTitle("Create Professional Ruleset");
  const navigate = useNavigate();
  const { setIsLoading } = useLoading();
  const { current: toastElement } = useContext(ToastContext);
  const [createMutation, { isLoading }] =
    useCreateProfessionalRulesetMutation();
  const [formData, setFormData] = useState<IProfessionalRulesetFormData>(
    INITIAL_PROFESSIONAL_FORM_DATA
  );

  const handleSubmit = async () => {
    if (!formData.providerId || formData.payerId === null) return;
    setIsLoading(true);
    try {
      await createMutation({
        providerId: formData.providerId,
        payerId: formData.payerId,
        compoundBilateralAndMppr: formData.compoundBilateralAndMppr,
        endoApplies: formData.endoApplies,
        disabledEndoBaseCptCodes: formData.disabledEndoBaseCptCodes,
      }).unwrap();
      toastElement?.show({
        severity: "success",
        summary: "Created!",
        detail: "Professional ruleset created successfully.",
      });
      navigate("/payer-rules");
    } catch (error: any) {
      toastElement?.show({
        severity: "error",
        summary: "Error",
        detail: error?.data?.message || "Failed to create professional ruleset",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <ProfessionalRulesetForm
      title="Create Professional Ruleset"
      submitLabel="Create Ruleset"
      formData={formData}
      onChange={setFormData}
      onSubmit={handleSubmit}
      isSubmitting={isLoading}
    />
  );
}
